import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import Home from "./pages/Home";

const Casino = lazy(() => import("./pages/route-pages/Casino"));
const Minigames = lazy(() => import("./pages/route-pages/Minigames"));
const Lottery = lazy(() => import("./pages/route-pages/Lottery"));
const TableGames = lazy(() => import("./pages/route-pages/TableGames"));
const Slots = lazy(() => import("./pages/route-pages/Slots"));
const Cricket = lazy(() => import("./pages/route-pages/Cricket"));
const Bonus = lazy(() => import("./pages/route-pages/Bonus"));
const LuckySpin = lazy(() => import("./pages/route-pages/LuckySpin"));
const Jetx = lazy(() => import("./pages/route-pages/Jetx"));
const Deposit = lazy(() => import("./pages/Deposit/Deposit"));
const Profile = lazy(() => import("./pages/route-pages/Profile"));
const VipLavel = lazy(() => import("./pages/route-pages/VipLavel"));
const BonusRecord = lazy(() => import("./pages/route-pages/BonusRecord"));
const Massage = lazy(() => import("./pages/route-pages/Massage"));
const TransationDet = lazy(() => import("./pages/route-pages/TransationDet"));
const BetInfo = lazy(() => import("./pages/route-pages/BetInfo"));
const Promotion = lazy(() => import("./components/ReusableComponent/Promotion"));
const Blog = lazy(() => import("./pages/route-pages/Blog"));
const Sports = lazy(() => import("./pages/route-pages/lobby-sub-components/Sports"));
const Multi = lazy(() => import("./pages/route-pages/Multi"));
const Baseball = lazy(() => import("./pages/route-pages/Baseball"));
const Soccer = lazy(() => import("./pages/route-pages/Soccer"));
const Tennis = lazy(() => import("./pages/route-pages/Tennis"));
const Handball = lazy(() => import("./pages/route-pages/Handball"));
const Rugby = lazy(() => import("./pages/route-pages/Rugby"));
const IceHockey = lazy(() => import("./pages/route-pages/IceHockey"));
const TableTennis = lazy(() => import("./pages/route-pages/TableTennis"));
const Futsal = lazy(() => import("./pages/route-pages/Fustal"));
const Test = lazy(() => import("./pages/route-pages/Test"));

export const GugoExchnageRoutes = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Home /> },
      { path: "sports", element: <Suspense fallback={<div>Loading...</div>}><Sports /></Suspense> },
      { path: "casino", element: <Suspense fallback={<div>Loading...</div>}><Casino /></Suspense> },
      { path: "mini-games", element: <Suspense fallback={<div>Loading...</div>}><Minigames /></Suspense> },
      { path: "lottery", element: <Suspense fallback={<div>Loading...</div>}><Lottery /></Suspense> },
      { path: "table-games", element: <Suspense fallback={<div>Loading...</div>}><TableGames /></Suspense> },
      { path: "slots", element: <Suspense fallback={<div>Loading...</div>}><Slots /></Suspense> },
      { path: "bonus", element: <Suspense fallback={<div>Loading...</div>}><Bonus /></Suspense> },  
      { path: "jetx", element: <Suspense fallback={<div>Loading...</div>}><Jetx /></Suspense> },
      { path: "deposit", element: <Suspense fallback={<div>Loading...</div>}><Deposit /></Suspense> },
      { path: "myProfile", element: <Suspense fallback={<div>Loading...</div>}><Profile /></Suspense> },
      { path: "vipLavel", element: <Suspense fallback={<div>Loading...</div>}><VipLavel /></Suspense> },
      { path: "bonusRecord", element: <Suspense fallback={<div>Loading...</div>}><BonusRecord /></Suspense> },
      { path: "message", element: <Suspense fallback={<div>Loading...</div>}><Massage /></Suspense> },
      { path: "transationDetails", element: <Suspense fallback={<div>Loading...</div>}><TransationDet /></Suspense> },
      { path: "betinfo", element: <Suspense fallback={<div>Loading...</div>}><BetInfo /></Suspense> },
      { path: "promotion", element: <Suspense fallback={<div>Loading...</div>}><Promotion /></Suspense> },
      { path: "blog", element: <Suspense fallback={<div>Loading...</div>}><Blog /></Suspense> },
    ],
  },
  { path: "lucky-spin", element: <Suspense fallback={<div>Loading...</div>}><LuckySpin /></Suspense> },
  { path: "cricket", element: <Suspense fallback={<div>Loading...</div>}><Cricket /></Suspense> },
  { path: "multi", element: <Suspense fallback={<div>Loading...</div>}><Multi /></Suspense> },
  { path: "basketball", element: <Suspense fallback={<div>Loading...</div>}><Baseball /></Suspense> },
  { path: "soccer", element: <Suspense fallback={<div>Loading...</div>}><Soccer /></Suspense> },
  { path: "tennis", element: <Suspense fallback={<div>Loading...</div>}><Tennis /></Suspense> },
  { path: "handball", element: <Suspense fallback={<div>Loading...</div>}><Handball /></Suspense> },
  { path: "rugby", element: <Suspense fallback={<div>Loading...</div>}><Rugby /></Suspense> },
  { path: "iceHockey", element: <Suspense fallback={<div>Loading...</div>}><IceHockey /></Suspense> },
  { path: "tableTennis", element: <Suspense fallback={<div>Loading...</div>}><TableTennis /></Suspense> },
  { path: "futsal", element: <Suspense fallback={<div>Loading...</div>}><Futsal /></Suspense> },
  { path: "test", element: <Suspense fallback={<div>Loading...</div>}><Test /></Suspense> },
]);
